import { ApiEndpoints } from "../models/ApiEndpoints";
import { ApiMethods } from "../models/ApiMethods";
import {
  CreateTagRequest,
  DeleteTagRequest,
  FlatVsaaTag,
  SortTagRequest,
  UpdateTagRequest,
  RearrangeTagRequest,
  CopyTagRequest,
  ImportTagRequest,
} from "../models/VsaaTag";
import {
  useApiGet,
  ApiGetHook,
  ApiMutateHook,
  useApiMutate,
} from "@skanska/vsa-client-auth";

export function useTagsGet(tagCollectionId: string): ApiGetHook<FlatVsaaTag[]> {
  return useApiGet<FlatVsaaTag[]>(
    ApiEndpoints.Tags,
    tagCollectionId,
    `tagcollectiontags-${tagCollectionId}`
  );
}

export function useOptionalTagsGet(
  tagCollectionId?: string
): ApiGetHook<FlatVsaaTag[]> {
  return useApiGet<FlatVsaaTag[]>(
    ApiEndpoints.Tags,
    tagCollectionId ?? "",
    `tagcollectiontags-${tagCollectionId ?? "missing"}`,
    { enabled: Boolean(tagCollectionId) }
  );
}

export function useTagsCreate(
  tagCollectionId: string
): ApiMutateHook<FlatVsaaTag, CreateTagRequest> {
  return useApiMutate<FlatVsaaTag, CreateTagRequest>(
    ApiEndpoints.Tags,
    ApiMethods.Post,
    null,
    null,
    [`tagcollectiontags-${tagCollectionId}`, `roles-${tagCollectionId}`]
  );
}

export function useTagsDelete(
  tagCollectionId: string
): ApiMutateHook<void, DeleteTagRequest> {
  return useApiMutate<void, DeleteTagRequest>(
    ApiEndpoints.Tags,
    ApiMethods.Delete,
    null,
    null,
    [`tagcollectiontags-${tagCollectionId}`, `roles-${tagCollectionId}`]
  );
}

export function useTagsUpdate(
  tagCollectionId: string
): ApiMutateHook<FlatVsaaTag, UpdateTagRequest> {
  return useApiMutate<FlatVsaaTag, UpdateTagRequest>(
    ApiEndpoints.TagsUpdate,
    ApiMethods.Patch,
    null,
    null,
    [`tagcollectiontags-${tagCollectionId}`, `roles-${tagCollectionId}`, "tagcollections"]
  );
}

export function useTagsSort(
  tagCollectionId: string
): ApiMutateHook<FlatVsaaTag, SortTagRequest> {
  return useApiMutate<FlatVsaaTag, SortTagRequest>(
    ApiEndpoints.TagsSort,
    ApiMethods.Patch,
    null,
    null,
    [`tagcollectiontags-${tagCollectionId}`, `roles-${tagCollectionId}`]
  );
}

export function useTagsRearrange(
  tagCollectionId: string
): ApiMutateHook<FlatVsaaTag, RearrangeTagRequest> {
  return useApiMutate<FlatVsaaTag, RearrangeTagRequest>(
    ApiEndpoints.TagsRearrange,
    ApiMethods.Patch,
    null,
    null,
    [`tagcollectiontags-${tagCollectionId}`, `roles-${tagCollectionId}`]
  );
}

export function useTagsCopy(
  tagCollectionId: string
): ApiMutateHook<FlatVsaaTag, CopyTagRequest> {
  return useApiMutate<FlatVsaaTag, CopyTagRequest>(
    ApiEndpoints.TagsCopy,
    ApiMethods.Post,
    null,
    null,
    [`tagcollectiontags-${tagCollectionId}`, `roles-${tagCollectionId}`]
  );
}

export function useTagsImport(
  tagCollectionId: string
): ApiMutateHook<void, ImportTagRequest> {
  return useApiMutate<void, ImportTagRequest>(
    ApiEndpoints.TagsImport,
    ApiMethods.Patch,
    null,
    null,
    [`tagcollectiontags-${tagCollectionId}`, `roles-${tagCollectionId}`]
  );
}
